<template>
  <section class="section container">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("orders") }}
      </h1>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('work order')"
            :placeholder="$t('select order')"
            url="/work_order/catalog"
            :is_multiple="false"
            name_field="alternate_name"
            value_field="order_id"
            @selected="set_orders"
          />
        </div>
      </div>
      <div class="column">
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("query") }}</label>
              <div class="columns">
                <div class="column">
                  <div class="control">
                    <button class="button is-rounded is-primary" @click="query">
                      <span class="icon"><i class="fa fa-bolt"></i></span>
                      <span>{{ $t("query") }}</span>
                    </button>
                  </div>
                </div>
                <div class="column">
                  <div class="control">
                    <div
                      class="is-info is-rounded button"
                      @click="download_excel"
                    >
                      <span class="icon"><i class="fa fa-download"></i></span>
                      <span>{{ $t("download excel") }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="title is-5">{{ $t("orders") }}</div>
      <!-- <pre>{{ orders }}</pre> -->
      <div>
        <table class="table is-fullwidth">
          <thead>
            <tr>
              <th>{{ $t("program") }}</th>
              <th>{{ $t("order number") }}</th>
              <th>{{ $t("name") }}</th>
              <th>{{ $t("products") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(order, spidx) in orders" :key="spidx">
              <td>{{ order.grade }}</td>
              <td>{{ order.order_number }}</td>
              <td>
                <div>{{ order.name }}</div>
                <div>
                  <ul
                    v-if="
                      order.settings &&
                      order.settings.comments &&
                      order.settings.comments.length
                    "
                  >
                    <li
                      v-for="(comment, cidx) in order.settings.comments"
                      :key="cidx"
                    >
                      <div class="title is-7">{{ comment.comment }}</div>
                      <div class="subtitle is-7">
                        {{ format_date(comment.create_date) }}
                      </div>
                    </li>
                  </ul>
                </div>
              </td>
              <td>
                <div v-for="(item, iidx) in order.tailoring_order_items">
                  <div>
                    {{ item.quantity }} x {{ item.product.name }}
                    {{ $t("size") }} {{ item.size.toUpperCase() }}
                    <span v-if="item.customization"
                      >({{ item.customization }})</span
                    >
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
import {
  get,
  generate_datatables_buttons,
  error_message,
  put,
  post,
  del,
  confirm_deletion_dialog,
  success_message,
  format_date_time,
  format_date,
  format_time,
  format_currency,
} from "@/utils";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import GenericCalendar from "@/components/generic_calendar/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import { groupBy } from "lodash";
// import { size } from "lodash";
import XLSX from "xlsx/dist/xlsx.full.min.js";

export default {
  name: "ProductOrder2Report",
  components: { GenericTable, GenericCalendar, GenericDropdown },
  data() {
    let v = this;
    return {
      orders: [],
      meta: {},
    };
  },
  computed: {},
  methods: {
    format_date_time,
    format_date,
    format_time,
    format_currency,
    query() {
      let v = this;
      let data = {
        args: v.meta,
        report_uuid: v.$route.params.id,
        method: "qq",
      };
      post("/report/query", data)
        .then((r) => {
          v.orders = r;
        })
        .catch((error) => {
          error_message(error);
        });
    },
    set_orders(orders) {
      let v = this;
      if (orders) {
        if (Array.isArray(orders))
          v.meta.orders = orders.map((p) => p.order_id);
        else v.meta.orders = [orders.order_id];
      }
    },
    download_excel() {
      let v = this;
      let data = v.orders.map((itm) => {
        return {
          [v.$t("program")]: itm.grade,
          [v.$t("order number")]: itm.order_number,
          [v.$t("name")]: itm.name,
          [v.$t("products")]: itm.tailoring_order_items.reduce((prev, curr) => {
            return `${prev}${curr.quantity} x ${curr.product.name} ${v.$t(
              "size"
            )} ${curr.size.toUpperCase()} ${curr.customization || ""}\n`;
          }, ""),
          // [v.$t("quantity")]: itm.quantity,
          // [v.$t("product")]: itm.product_name,
          // [v.$t("size")]: itm.size,
          // [v.$t("grade")]: itm.grade,
          // // [v.$t("source")]: itm.source,
          // [v.$t("customization")]: itm.customization,
        };
      });
      let ws = XLSX.utils.json_to_sheet(data);
      let wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, "product_orders.xlsx");
    },
  },
  mounted() {},
};
</script>

<style>
/* Add Bulma styles here */
</style>
